import React, { useState, useEffect } from 'react';
import moment from 'moment';
// import './Calendar.css'; // Make sure this path is correct for your styles

const Calendar = ({ Toolbar, dateCellWrapper: DateCellWrapperProp, selectedDate, setSelectedDate, availableDates }) => {
  // Use selectedDate from props to initialize and keep in sync
  const [currentMonthMoment, setCurrentMonthMoment] = useState(() => {
    const m = selectedDate ? moment(selectedDate) : moment();
    return m.isValid() ? m.startOf('month') : moment().startOf('month');
  });

  // Effect to update internal currentMonthMoment when selectedDate prop changes (e.g., from parent)
  useEffect(() => {
    if (!selectedDate) return; // Skip when selectedDate is null to avoid invalid moment
    const selectedMoment = moment(selectedDate);
    if (selectedMoment.isValid() && !selectedMoment.isSame(currentMonthMoment, 'month')) {
      setCurrentMonthMoment(selectedMoment.startOf('month'));
    }
  }, [selectedDate]); // Depend on selectedDate prop

  // Function to render the days of the month
  const renderCalendarDays = () => {
    const startOfMonth = currentMonthMoment.clone().startOf('month');
    const daysInMonth = currentMonthMoment.daysInMonth();
    const firstDay = startOfMonth.day(); // 0 for Sunday, 1 for Monday, etc.

    const calendarDays = [];


    // Add empty cells for days before the 1st of the month
    for (let i = 0; i < firstDay; i++) {
      calendarDays.push(<div key={`empty-${i}`} className="calendar-day empty"></div>);
    }

    // Add actual days of the month
    for (let day = 1; day <= daysInMonth; day++) {
      const dayMoment = moment(currentMonthMoment).date(day); // Create a Moment object for the current day
      const isCurrentDay = dayMoment.isSame(moment(), 'day'); // Check if it's today
      const isSelectedDay = dayMoment.isSame(selectedDate, 'day'); // Check if it's the selected day
      const isAvailableDay = availableDates?.some(availDate =>
        moment(availDate).isSame(dayMoment, 'day')
      );

      const dayClasses = ['calendar-day'];
      if (isCurrentDay) dayClasses.push('current-day');
      if (isSelectedDay && isAvailableDay) dayClasses.push('selected-available-day');
      else if (isSelectedDay) dayClasses.push('selected-day');
      if (isAvailableDay) dayClasses.push('available-day');
      else dayClasses.push('unavailable-day'); // Add a class for unavailable days

      const handleDayClick = () => {
        if (isAvailableDay) {
          setSelectedDate(dayMoment.toDate()); // Update the selected date in the parent component
        }
      };

      // Use the DateCellWrapperProp if provided, otherwise render a simple div
      const DayComponent = DateCellWrapperProp || 'div';

      calendarDays.push(
        <DayComponent
          value={dayMoment.toDate()} // Value prop for the wrapper
          key={`day-${day}`}
          className={dayClasses.join(' ')}
          onClick={handleDayClick}
        >
          {/* Ensure children are passed for the wrapper to render the day number */}
          {day}
        </DayComponent>
      );
    }
    return calendarDays;
  };

  const goToPrevMonth = () => {
    setCurrentMonthMoment(prevMonth => {
      const newMonth = prevMonth.clone().subtract(1, 'month');
      // Logic to select an available date or first day in new month
      // const firstAvailableInNewMonth = availableDates?.find(date =>
      //   moment(date).isSame(newMonth, 'month')
      // );
      // if (firstAvailableInNewMonth) {
      //   setSelectedDate(firstAvailableInNewMonth);
      //   return moment(firstAvailableInNewMonth);
      // } else {
      setSelectedDate(newMonth.clone().startOf('month').toDate());
      return newMonth;
      // }
    });
  };

  const goToNextMonth = () => {
    setCurrentMonthMoment(prevMonth => {
      const newMonth = prevMonth.clone().add(1, 'month');
      // Logic to select an available date or first day in new month
      // const firstAvailableInNewMonth = availableDates?.find(date =>
      //   moment(date).isSame(newMonth, 'month')
      // );
      // if (firstAvailableInNewMonth) {
      //   setSelectedDate(firstAvailableInNewMonth);
      //   return moment(firstAvailableInNewMonth);
      // } else {
      setSelectedDate(newMonth.clone().startOf('month').toDate());
      return newMonth;
      // }
    });
  };

  // Prepare props for the Toolbar component
  const toolbarProps = {
    // label: currentMonthMoment.format('MMMM YYYY'), // Dynamic label
    date: currentMonthMoment.toDate(), // Pass the current month's date
    onNavigate: (action) => {
      // Mimic react-big-calendar's onNavigate actions
      if (action === 'PREV') goToPrevMonth();
      if (action === 'NEXT') goToNextMonth();
      // You can add 'TODAY' if you have a button for it in your CustomToolbar
    },
    // You might also want to pass 'view' if your Toolbar uses it, though for month view it's less critical.
    // view: 'month',
  };


  return (
    <div className="calendar"> {/* Added container for styling */}
      {Toolbar && <Toolbar {...toolbarProps} />} {/* Render Toolbar if provided */}
      {!Toolbar && ( // Fallback if no custom Toolbar is provided
        <div className="calendar-header">
          <button onClick={goToPrevMonth}>&lt;</button>
          <h2>{currentMonthMoment.format('MMMM YYYY')}</h2>
          <button onClick={goToNextMonth}>&gt;</button>
        </div>
      )}
      <div className="calendar-grid">
        <div className="calendar-day-name">Sun</div>
        <div className="calendar-day-name">Mon</div>
        <div className="calendar-day-name">Tue</div>
        <div className="calendar-day-name">Wed</div>
        <div className="calendar-day-name">Thu</div>
        <div className="calendar-day-name">Fri</div>
        <div className="calendar-day-name">Sat</div>
        {renderCalendarDays()}
      </div>
    </div>
  );
};

export default Calendar;